import { Component } from "react";
import classNames from "classnames";
import uuidv1 from "uuid/v1";
import BoardContainer from "./BoardContainer";

export default class Board extends Component {
  constructor({ id }) {
    super();

    this.id = id || uuidv1();
  }

  render() {
    const { className } = this.props;
    const allClassNames = classNames("react-trello-board", className || "");
    return <BoardContainer id={this.id} {...this.props} className={allClassNames} />;
  }
}
